import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface WorldNavCountsResponse {
	regions: number;
	pointsOfInterest: number;
	nonPlayerCharacters: number;
	playerCharacters: number;
	factions: number;
	merchants: number;
	items: number;
	goodsServices: number;
	tomes: number;
	tomePages: number;
	quests: number;
	questRequirements: number;
	encounters: number;
	pantheons: number;
	gods: number;
	domains: number;
	[key: string]: number;
}

@Injectable({ providedIn: 'root' })
export class WorldNavCountsService {
	constructor(private readonly http: HttpClient) {}

	get(worldId: string): Observable<WorldNavCountsResponse> {
		return this.http.get<WorldNavCountsResponse>(
			`${environment.api.baseUrl}/v1/worlds/${worldId}/nav-counts`
		);
	}
}
